import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notify, Typography, Stack } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getWorkloadQueryKey } from 'hooks/queries/workload-optimization/useWorkloadQuery';
import { getWorkloadScalingPoliciesQueryKey } from 'hooks/queries/workload-optimization/useWorkloadScalingPoliciesQuery';
import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

type Options = {
  notifyOnSuccess?: boolean;
};

export const useUpdateWorkloadScalingPolicyOrderMutation = ({
  notifyOnSuccess = true,
}: Options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      clusterId,
      policyIds,
    }: {
      clusterId: string;
      policyIds: string[];
    }) =>
      apiClient.workloadOptimization.updateWorkloadScalingPoliciesOrder({
        body: { policyIds },
        clusterId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getWorkloadScalingPoliciesQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getWorkloadQueryKey() });
      queryClient.invalidateQueries({
        queryKey: getWorkloadsQueryKey(),
      });

      if (notifyOnSuccess) {
        notify.success(
          <Stack gap={4} direction="row">
            <Typography variant="P14B" color="green.200">
              SUCCESSFUL!
            </Typography>
            <Typography variant="P14R" color="#fff">
              Scaling policies reordered!
            </Typography>
          </Stack>
        );
      }
    },
  });
};
